
import React from 'react';

const About: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid md:grid-cols-2 gap-16 items-start">
        <div>
          <h2 className="text-xs font-mono text-emerald-500 uppercase tracking-[0.2em] mb-4">The Philosophy</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-8 leading-tight">
            Strategy is Cheap. <br />
            <span className="text-slate-500">Execution is Everything.</span>
          </h3>
        </div>
        
        <div className="space-y-6 text-lg text-slate-400 leading-relaxed">
          <p>
            Most growth problems aren't caused by a lack of ideas—they are caused by broken execution. Funnels leak, sales processes rely on manual grunt work, and data gets lost in the noise.
          </p>
          <p className="text-white font-medium">
            That is where I come in.
          </p>
          <p>
            I am a <span className="text-emerald-400">GTM Engineer</span>. I don't just advise on strategy; I architect and build the AI-powered systems that connect your Marketing, Sales, and Ops.
          </p>
          <p>
            My approach is simple: <span className="text-white">Remove friction. Automate the predictable. Scale the revenue.</span>
          </p>
          <p>
            Whether it's designing an automated outbound engine or a personalized retention loop, I build the infrastructure that turns "growth plans" into consistent reality.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
